<template>
  <div>
    <v-container>
      <v-layout wrap class="pt-4">
        <v-flex xs12 sm6 class="text-sm-left text-xs-left">
          <importxlsx :loading="importLoading" @onChange="handleImport" :noraw="true"></importxlsx>
          <v-btn dark outline color="primary" @click="downloadImportTemplate">
            <em class="fas fa-download" />&nbsp;Download template
          </v-btn>
        </v-flex>
        <v-flex xs12 sm6 class="text-sm-right text-xs-right">
          <v-btn depressed color="primary" @click="showSearch = true" class="ma-0 mr-1">
            <v-icon>search</v-icon>&nbsp;{{ $t('advanced search') }}
          </v-btn>
          <v-btn dark outline color="primary" @click="handleExportXlsx" :loading="loading">
            <em class="fas fa-file-export" />&nbsp;{{ $t('export') }}
          </v-btn>
        </v-flex>
      </v-layout>
      <v-data-table
        hide-actions
        :loading="loading"
        :headers="headers"
        :items="branchData"
        :pagination.sync="pagination"
        class="elevation-1 mt-3"
      >
        <template slot="headerCell" slot-scope="props">
          <HeaderTableWithSort
            :headers="props.header"
            :sortBy.sync="sortBy"
            :orderBy.sync="orderBy"
            @onSort="handleChangeSort"
          ></HeaderTableWithSort>
        </template>
        <template v-slot:items="props">
          <tr>
            <td>{{ props.item.branch_id }}</td>
            <td>{{ props.item.branch_name }}</td>
            <td>{{ props.item.affiliation }}</td>
            <td>{{ props.item.province }}</td>
            <td>{{ props.item.end_point || '-' }}</td>
            <td>
              <v-btn
                outline
                fab
                small
                color="primary"
                @click="handleDeleteBranch(props.item.branch_id)"
              >
                <v-icon>delete</v-icon>
              </v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div class="mt-2">
        <v-pagination
          :total-visible="6"
          v-model="pageNumber"
          @input="changePage"
          :length="pagelength"
        ></v-pagination>
      </div>

      <v-dialog v-model="showSearch" persistent width="400px">
        <SearchBranchDialog @close="handleCloseSearch" @onSearch="onSearch"></SearchBranchDialog>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import yasaleAcApi from '@/api/yasale-ac'
import { mapGetters } from 'vuex'
import XLSX from 'xlsx'
import importxlsx from '@/components/elements/importxlsx.vue'
import SearchBranchDialog from './SearchBranchDialog.vue'
import HeaderTableWithSort from '@/components/elements/HeaderTableWithSort.vue'
import { ORDER_BY } from '@/constants/orderBy.js'

export default {
  components: {
    importxlsx,
    SearchBranchDialog,
    HeaderTableWithSort
  },
  data() {
    return {
      limit: 10,
      offset: 0,
      pagination: { rowsPerPage: -1, sortBy: '' },
      total: 0,
      pagetmp: 1,
      pageNumber: 1,
      importLoading: false,
      showSearch: false,
      loading: false,
      filter: {},
      branchData: [],
      headers: [
        { text: 'รหัสศูนย์', value: 'branch_id', customSort: true, sortable: false },
        { text: 'ชื่อศูนย์', value: 'branch_name', customSort: true, sortable: false },
        { text: 'สาขา', value: 'affiliation', customSort: true, sortable: false },
        { text: 'จังหวัด', value: 'province', customSort: true, sortable: false },
        { text: 'IP Address', value: 'end_point', customSort: false, sortable: false },
        { text: '', customSort: false, sortable: false }
      ],
      sortBy: 'branch_id',
      orderBy: ORDER_BY.DESC
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        var total = parseFloat(this.total)
        return Math.ceil(total / this.limit)
      } else {
        return 1
      }
    }
  },
  async mounted() {
    await this.handleGetBranch()
  },
  methods: {
    async handleGetBranch() {
      const vm = this
      try {
        const response = await vm.getBranch()
        if (response) {
          vm.branchData = response.data
          vm.total = response.total
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    async getBranch() {
      const vm = this
      return new Promise(async (resolve, reject) => {
        const limit = vm.isExport ? vm.total : vm.limit
        let data = {
          page_id: vm.selectedBot.pageid,
          limit: limit,
          offset: vm.offset,
          sort_by: vm.sortBy,
          order_by: vm.orderBy
        }

        if (this.filter.branch_id) {
          Object.assign(data, { branch_id: this.filter.branch_id })
        }
        if (this.filter.branch_name) {
          Object.assign(data, { branch_name: this.filter.branch_name })
        }
        if (this.filter.affiliation) {
          Object.assign(data, { affiliation: this.filter.affiliation })
        }
        if (this.filter.province) {
          Object.assign(data, { province: this.filter.province })
        }

        vm.loading = true
        const response = await yasaleAcApi.getBranch({
          config: {
            params: data
          }
        })

        vm.loading = false
        if (response && response.status === 200) {
          resolve(response.data)
        } else {
          reject(null)
        }
      })
    },
    transformHeaderField(data) {
      const result = []
      try {
        data.forEach((item) => {
          const tempItem = {
            branch_id: '',
            branch_name: '',
            affiliation: '',
            province: '',
            end_point: ''
          }

          Object.keys(item).forEach((element) => {
            switch (element) {
              case 'สาขา':
                tempItem.affiliation = item[element]
                break
              case 'รหัสศูนย์':
                tempItem.branch_id = item[element]
                break
              case 'จังหวัด':
                tempItem.province = item[element]
                break
              case 'ชื่อศูนย์':
                tempItem.branch_name = item[element]
                break
              case 'IP Address':
                tempItem.end_point = item[element]
                break
              default:
              // code block
            }
          })
          result.push(tempItem)
        })
        return result
      } catch (error) {
        console.error(error)
        return []
      }
    },
    async handleImport(item) {
      const vm = this
      try {
        vm.importLoading = true
        const data = {
          page_id: vm.selectedBot.pageid,
          data: vm.transformHeaderField(item[0])
        }

        const response = await yasaleAcApi.importBranch({ data })
        vm.importLoading = false

        if (response && response.status === 200) {
          await vm.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          vm.reset()
        } else {
          await vm.$swal.fire({
            text: 'ข้อมูลไม่ถูกต้อง'
          })
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    downloadImportTemplate() {
      const data = []
      const heading = [['รหัสศูนย์', 'ชื่อศูนย์', 'สาขา', 'จังหวัด', 'IP Address']]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, data)
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `template-import-branch.xlsx`)
    },
    async handleExportXlsx() {
      const vm = this
      vm.isExport = true
      const data = await vm.getBranch()
      const branchData = data.data
      vm.isExport = false

      if (branchData == null) return
      const branchs = branchData.map((el) => {
        return {
          branch_id: el.branch_id,
          branch_name: el.branch_name,
          affiliation: el.affiliation,
          province: el.province,
          end_point: el.end_point
        }
      })

      const heading = [['รหัสศูนย์', 'ชื่อศูนย์', 'สาขา', 'จังหวัด', 'IP Address']]

      const wb = XLSX.utils.book_new()
      const ws = XLSX.utils.json_to_sheet([])
      XLSX.utils.sheet_add_aoa(ws, heading)
      XLSX.utils.sheet_add_json(ws, branchs, { origin: 'A2', skipHeader: true })
      XLSX.utils.book_append_sheet(wb, ws)
      XLSX.writeFile(wb, `yasale-ac-branch.xlsx`)
    },
    handleDeleteBranch(id) {
      this.$swal
        .fire({
          icon: 'error',
          text: 'คุณต้องการลบใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: 'ยกเลิก',
          confirmButtonText: 'ตกลง'
        })
        .then((result) => {
          if (result.value) {
            this.deleteBranch(id)
          }
        })
    },
    async deleteBranch(id) {
      const vm = this
      try {
        let data = {
          page_id: vm.selectedBot.pageid,
          id: id
        }
        const response = await yasaleAcApi.deleteBranch({ data: data })
        if (response && response.status === 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
          vm.handleGetBranch()
        }
      } catch (error) {
        console.error(error)
        return
      }
    },
    onSearch(payload) {
      this.filter = { ...payload }
      this.reset()
      this.handleCloseSearch()
    },
    handleCloseSearch() {
      this.showSearch = false
    },
    changePage(val) {
      const vm = this
      if (vm.pagetmp !== val) {
        vm.pagetmp = val
        vm.offset = vm.pageNumber * vm.limit - vm.limit
        vm.handleGetBranch()
      }
    },
    reset() {
      this.offset = 0
      this.pagetmp = 1
      this.pageNumber = 1
      this.handleGetBranch()
    },
    handleChangeSort() {
      this.reset()
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/YasaleAc/BranchManagement.vue